module.exports = __webpack_public_path__ + "img/2019プール掃除.da8267fa.jpg";